import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./alertgrid-widget.html';
import DataRepository from '../../../app/data-framework/data-repository';
import _ from 'lodash';
import DataProvider from "../../../app/data-framework/data-provider";

  function AlertgridWidget(params) {
      var self = this;

      self.observableOptions = params.observableOptions;
      self.observableData = params.observableData;
      self.panelTemplate = params.panelTemplate;
      self.widgetSignals = params.widgetSignals;
      self.dataProvider = DataProvider.getInstance();

      self.dataRepository = DataRepository.getInstance();
      self.metadata = self.dataRepository.getAlertsMetadata();

      self.flexQueryOptions = ko.observable({ WhereConditionObj : []});
      self.typeaheadOptions = ko.observable(self.metadata.typeaheadConditions);

      //trigger load
      if (params.observableParamsList && params.observableParamsList[0]) {
        params.observableParamsList[0].valueHasMutated();
      }

      //trigger load on add modal close
      $("#AlertModal").on('hidden.bs.modal', function (e) {
          params.observableParamsList[0].valueHasMutated();
      });

      var savedFilters = self.observableOptions().filter;
      var defmodifier = "all";

      self.subscriptions = [];

      if (savedFilters && savedFilters.modifier) {
        defmodifier = savedFilters.modifier;
      }

      if (savedFilters && !_.isEmpty(savedFilters.search)) {
          self.flexQueryOptions({ WhereConditionObj: [{ conditions: savedFilters.search }] });
      }

      self.modifier = ko.observable(defmodifier);

      self.subscriptions.push(self.modifier.subscribe(function (newValue) {

          var options = self.observableOptions();

          if (!options.filter) {
              options.filter = {};
          }

          options.filter.modifier = newValue;

          if (self.widgetSignals) {
              self.widgetSignals().dataRequested.dispatch();
          }

          self.observableOptions(options);
      }));

      self.subscriptions.push(self.flexQueryOptions.subscribe(function(newValue) {
          var options = self.observableOptions();

          if (!options.filter) {
              options.filter = {};
          }

          options.filter.search = _.get(newValue, 'WhereConditionObj[0].conditions', []);

          if (self.widgetSignals) self.widgetSignals().dataRequested.dispatch();

          self.observableOptions(options);
      }))

      self.RefreshData();
  }

  AlertgridWidget.prototype.RefreshData = function () {};

    AlertgridWidget.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    AlertgridWidget.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };
  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    AlertgridWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

  export default { viewModel: AlertgridWidget, template: templateMarkup };


